import React from 'react'
import { Grid, Form } from 'semantic-ui-react'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { GridContainer } from 'shared/StyledComponents'
import { DataSegment } from 'shared/Helpers'
import LKModal, { LKModalContainer, LKModalTrigger } from 'shared/LKModal'
import { translateWriteOff } from '../../translator'
import { connect } from 'react-redux'
import { getwriteOffData } from 'src/store/loan'
import { actions as LKModalActions } from 'src/features/shared/LKModal'

const LOAN_WRITE_OFF_DATA_MODAL = 'LOAN_WRITE_OFF_DATA_MODAL'

const container = connect(undefined, (dispatch) => ({
  getwriteOffData: (params) => dispatch(getwriteOffData(params)),
  openError: (errorText) => dispatch(LKModalActions.openError(errorText)),
}))
class LoanWriteOffDataModal extends React.PureComponent {
  state = { fetching: false }

  componentDidMount() {
    this.handleOpen()
  }

  handleOpen = async () => {
    this.setState({ fetching: true })

    // const data = await Loan.writeOffData({
    //   LoanID: this.props.ID,
    //   HashSum_LoanID_: this.props.hash,
    // })

    //UPDATED API REQUEST loan_view_api page: writeoffdata
    const result = await this.props.getwriteOffData({
      LoanID: this.props.ID,
      HashSum_LoanID_: this.props.hash,
    })

    if (!getwriteOffData.fulfilled.match(result)) {
      this.props.openError(result.payload)
      this.setState({ fetching: false })
      return
    }

    this.setState({ fetching: false, ...result.payload })
  }

  render() {
    const { modalInstanceName } = this.props
    const { fetching, WriteOffDate, Principal, Interest, PenaltyPri, PenaltyInt, UCLC, Comment, Comment2 } = this.state
    console.log(this.props)
    return (
      <LKModal
        name={modalInstanceName}
        heading={translateWriteOff('frm_loan_writeoff_detail')}
        loading={fetching}
        size="medium"
        footer={<LKModal.Footer sideActions={<LKModal.CancelButton text={translateWriteOff('cmd_close')} />} />}
      >
        <Form>
          <GridContainer>
            <Grid>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_recdate')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment>{LKDate.from(WriteOffDate).toString()}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_principal')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment>{(Principal || 0).toFixed(2)}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_interest')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment>{(Interest || 0).toFixed(2)}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_penaltypri')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment>{(PenaltyPri || 0).toFixed(2)}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_penaltyint')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment>{(PenaltyInt || 0).toFixed(2)}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_uclc_t')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment>{(UCLC || 0).toFixed(2)}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_comment_t')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment style={{ height: '100px' }}>{Comment}</DataSegment>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={6} textAlign="right" verticalAlign="middle">
                  <label>{translateWriteOff('lbl_details_t')}</label>
                </Grid.Column>

                <Grid.Column width={10}>
                  <DataSegment style={{ height: '100px' }}>{Comment2}</DataSegment>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </GridContainer>
        </Form>
      </LKModal>
    )
  }
}

export const LoanWriteOffDataModalTrigger = () => <LKModalTrigger alias="info" name={LOAN_WRITE_OFF_DATA_MODAL} />

export default LKModalContainer(LOAN_WRITE_OFF_DATA_MODAL)(container(LoanWriteOffDataModal))
